import { requireAuthOrProspectEmail } from '../../guards';

export const path = '/start-order';
export const component = 'StartOrder';
export const thunk = () => requireAuthOrProspectEmail;
